import { createSelector } from 'reselect';
import I18n from 'I18n';
import { getNumToSendTo
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/RecipientsSelectors';
import { getIsLocalTime, getIsAbTest
// @ts-expect-error module not yet migrated
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getMaximumRateLimitPerMinute } from 'EmailEditorUI/StaggerSends/selectors/StaggerSendsSelectors';
import { getPublishingOption } from 'EmailEditorUI/redux/selectors/scheduleSelectors';
import { NEW_PUBLISH_OPTIONS } from 'EmailEditorUI/constants/publishOptions';
import { MINIMUM_SEND_SPEED, MAXIMUM_SEND_SPEED, SEND_SPEED_ERRORS } from 'EmailEditorUI/StaggerSends/constants';
export const getIsEstimatedSendTimeHidden = createSelector([getIsLocalTime, getIsAbTest, getPublishingOption], (isLocalTime, isAB, publishingOption) => {
  const isContactSTO = publishingOption === NEW_PUBLISH_OPTIONS.CONTACT_STO;
  return isContactSTO || isLocalTime || isAB;
});
export const getEstimatedSendTime = createSelector([getNumToSendTo, getMaximumRateLimitPerMinute], (numToSendTo, maximumRateLimitPerMinute) => {
  if (!maximumRateLimitPerMinute) {
    return null;
  }
  const estimatedSendTimeInMinutes = numToSendTo / maximumRateLimitPerMinute;
  return Math.ceil(estimatedSendTimeInMinutes);
});
export const getEstimatedTimeDuration = createSelector([getEstimatedSendTime], estimatedSendTime => {
  if (!estimatedSendTime) {
    return null;
  }
  const duration = I18n.moment.duration(estimatedSendTime, 'minutes');
  const hours = duration.hours();
  const minutes = duration.minutes();
  const durationInMinutes = I18n.text('maximumRateLimit.timeUnits.minute', {
    count: minutes
  });
  const durationInHours = I18n.text('maximumRateLimit.timeUnits.hour', {
    count: hours
  });
  // If less than 60 minutes, show only minutes
  if (hours === 0) {
    return durationInMinutes;
  }

  // If exactly X hours with no remaining minutes
  if (minutes === 0) {
    return durationInHours;
  }

  // X hours Y minutes (e.g., 90 minutes = "1 hour 30 minutes")
  return `${durationInHours} ${durationInMinutes}`;
});
export const getSendSpeedError = createSelector([getNumToSendTo, getEstimatedSendTime, getMaximumRateLimitPerMinute], (numToSendTo, estimatedSendTime, maximumRateLimitPerMinute) => {
  const sendSpeed = {
    min: MINIMUM_SEND_SPEED,
    max: MAXIMUM_SEND_SPEED
  };
  let hasDynamicMinSpeed = false;
  // estimated send speed cannot exceed 24 hours - dynamically adjust min send speed
  if (!estimatedSendTime || Math.floor(estimatedSendTime / 60) >= 24) {
    const minSendSpeed = Math.ceil((numToSendTo || 0) / 1440);
    sendSpeed.min = Math.max(minSendSpeed, MINIMUM_SEND_SPEED);
    hasDynamicMinSpeed = sendSpeed.min !== MINIMUM_SEND_SPEED;
  }
  const {
    min,
    max
  } = sendSpeed;
  if (min >= max) {
    return {
      errorType: SEND_SPEED_ERRORS.EXCEEDS_THRESHOLD,
      min,
      max
    };
  }
  if (!maximumRateLimitPerMinute) {
    return {
      errorType: SEND_SPEED_ERRORS.EMPTY,
      min,
      max
    };
  }
  if (maximumRateLimitPerMinute < min) {
    return {
      errorType: hasDynamicMinSpeed ? SEND_SPEED_ERRORS.BELOW_DYNAMIC_MIN : SEND_SPEED_ERRORS.BELOW_MIN,
      min,
      max
    };
  }
  if (maximumRateLimitPerMinute > max) {
    return {
      errorType: SEND_SPEED_ERRORS.ABOVE_MAX,
      min,
      max
    };
  }
  return null;
});